<template>
  <section class="report-wrapper" id="pdf-content">
    <b-card no-body>
      <table class="w-100">
        <thead>
          <tr>
            <td>
              <div class="header-space">
                <b-card-body class="report_header w-100 pb-0">
                  <div class="company">
                    <h3 class="mb-1 text-left colorBlack">
                      {{ userData.company_name_cn }}
                    </h3>
                  </div>
                  <div class="title d-flex justify-content-between">
                    <h5 class="mb-0 colorBlack">還款明細表</h5>
                    <label>列印時間：{{ getDateTime() }}</label>
                  </div>
                  <div class="info my-50">
                    <b-row>
                      <b-col cols="10">
                        <b-row>
                          <b-col cols="6">
                            <b-row>
                              <b-col cols="4"><b>還款期限：</b></b-col>
                              <b-col
                                cols="8"
                                v-if="
                                  date_range.from ||
                                  date_range.to
                                "
                              >
                                {{ date_range.from }} -
                                {{ date_range.to }}
                              </b-col>
                              <b-col cols="8" v-else> 不限 </b-col>
                            </b-row>
                          </b-col>

                          <b-col cols="6">
                            <b-row>
                              <b-col cols="4"><b>貸款類別：</b></b-col>
                              <b-col
                                cols="8"
                                v-if="loan_type"
                                >{{ loan_type }}</b-col
                              >
                              <b-col cols="8" v-else> 不限 </b-col>
                            </b-row>
                          </b-col>
                        </b-row>
                      </b-col>
                    </b-row>
                  </div>
                </b-card-body>
              </div>
            </td>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>
              <b-card-body class="py-0 report_content w-100">
                <table class="report-table w-100">
                    <thead>
                      <tr>
                        <th>還款期限</th>
                        <th>貸款編號</th>
                        <th>客戶名稱</th>
                        <th>期數/總期數</th>
                        <th>應還本金</th>
                        <th>應還利息</th>
                        <th>應還本息和</th>
                      </tr>
                    </thead>
                  <tbody>
                    <tr v-for="item of reportList" :key="item.id">
                      <th>{{ item.pay_date }}</th>
                      <th>
                        {{
                          item.client_loan && item.client_loan.contract_number
                        }}
                      </th>
                      <th>
                        {{ item.client_loan && item.client_loan.name_cn }}
                      </th>
                      <th>
                        {{ item.period }}/{{
                          item.client_loan && item.client_loan.period
                        }}
                      </th>
                      <th>{{ formatCurrency(  item.principal) }}</th>
                      <th>{{ formatCurrency(item.interest) }}</th>
                      <th>
                        {{
                          formatCurrency(
                            Number(item.principal) + Number(item.interest)
                          )
                        }}
                      </th>
                    </tr>
                  </tbody>
                </table>
              </b-card-body>
            </td>
          </tr>
        </tbody>
        <tfoot>
          <tr>
            <td>
              <div class="footer-space">&nbsp;</div>
            </td>
          </tr>
        </tfoot>
      </table>

      <b-card-body class="report_footer py-0">
        <table class="report-table">
          <tfoot>
            <tr>
              <th></th>
              <th></th>
              <th></th>
              <th></th>
              <th>
                {{
                  formatCurrency(
                    reportList.reduce(
                      (acc, curr) => acc + Number(curr.principal),
                      0
                    )
                  )
                }}
              </th>
              <th>
                {{
                  formatCurrency(
                    reportList.reduce(
                      (acc, curr) => acc + Number(curr.interest),
                      0
                    )
                  )
                }}
              </th>
              <th>
                {{
                  formatCurrency(
                    reportList.reduce(
                      (acc, curr) =>
                        acc + (Number(curr.principal) + Number(curr.interest)),
                      0
                    )
                  )
                }}
              </th>
            </tr>
          </tfoot>
        </table>
        <b
          v-if="loading"
          class="d-flex justify-content-center align-items-center"
        >
          <b-spinner small class="mr-1"></b-spinner>
          載入中...
        </b>
        <b v-else-if="reportList.length == 0" class="d-flex justify-content-center"
          >沒有過濾或沒有符合條件的數據</b
        >
      </b-card-body>
    </b-card>
  </section>
</template>

<script>
import { BRow, BCol, BCard, BCardBody, BCardText, BSpinner } from "bootstrap-vue";


export default {
  data() {
    return {
      userData: JSON.parse(localStorage.getItem("userData")),
      month: [
        "Jan",
        "Feb",
        "March",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec",
      ],
    };
  },
  methods: {},
  components: {
    BRow,
    BCol,
    BCard,
    BCardBody,
    BCardText,
    BSpinner
  },
  props: {
    reportList: {
      type: Array,
      required: true,
    },
    loanTypeOptions: {
      type: Array,
      required: true,
    },
    date_range: {},
    loan_type: {},
    loading: {
      type: Boolean,
      required: true,
    },
  },

  mounted() {
    // this.$nextTick(() => {
    //     setTimeout(() => {
    //         this.$emit("domRendered");
    //     }, 1000);
    // });
  },
  computed: {
  },
};
</script>

<style lang="scss" scoped>
@import "~@core/scss/base/pages/app-invoice.scss";
@import "~@core/scss/base/components/variables-dark";
.report_content .report-table, .report_footer .report-table {
  th {
    width: 100px;
    padding: 0 2px;
    // &:nth-child(1),
    // &:nth-child(2),
    // &:nth-child(3),
    // &:nth-child(4) {
    //   width: 110px;
    // }
  }
}
</style>